import { FooterNav } from './FooterNav';
import { GET_IN_TOUCH_LINKS } from './links';

const CONTACT_EMAIL = 'info@thesolesupplier.co.uk';

export default function GetInTouch() {
  return (
    <div className="flex flex-col gap-4">
      <FooterNav label="Get in touch" links={GET_IN_TOUCH_LINKS} />
      <a className="break-words" href={`mailto:${CONTACT_EMAIL}`}>
        {CONTACT_EMAIL}
      </a>
      <address className="font-normal not-italic text-grey-hide">
        The Sole Supplier
        <br />
        3rd Floor
        <br />
        86-90 Paul Street
        <br />
        London EC2A 4NE
      </address>
    </div>
  );
}
